'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const universal_color = require('../../style/universal.color.js');
const skeleton = require('../Skeleton/skeleton.js');
const image = require('../Image/image.js');

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var sizeRange = [30, 60, 90, 120, 150, 180, 240];
var HeadshotFallback = 'https://prod-gameday.mlbstatic.com/responsive-gameday-assets/1.2.0/images/players/default-batter.svg';

var generateUrl = function generateUrl(scaling, playerId, zoomLevel, width) {
  var headshotWidth = width * scaling;
  var zoom = Math.round(headshotWidth / zoomLevel);
  return "https://img.mlbstatic.com/mlb-photos/image/upload/d_headshot_silo_generic.png,w_".concat(headshotWidth, ",h_").concat(headshotWidth, "/c_crop,w_").concat(zoom, ",g_face/v1/people/").concat(playerId, "/headshot/silo/current");
}; // want to keep to a range of acceepted sizes to keep asset costs down


var generateRoundedSize = function generateRoundedSize(width) {
  var rangeLength = sizeRange.length;
  var headshotWidth = sizeRange[rangeLength - 1];
  var widthNum = typeof width === 'string' ? width.replace('px', '') : width;

  for (var i = 0; i < rangeLength; i++) {
    if (sizeRange[i] >= widthNum) {
      headshotWidth = sizeRange[i];
      break;
    }
  }

  return headshotWidth;
};

var constructHeadshotURLSrcset = function constructHeadshotURLSrcset(playerId, zoomLevel, width) {
  // set img to appropriate width
  // TODO what if percentage?
  var headshotWidth = generateRoundedSize(width);
  return {
    '1x': generateUrl(1, playerId, zoomLevel, headshotWidth),
    '2x': generateUrl(2, playerId, zoomLevel, headshotWidth),
    '3x': generateUrl(3, playerId, zoomLevel, headshotWidth)
  };
};

var Headshot = function Headshot(props) {
  var _props$src = props.src,
      src = _props$src === void 0 ? '' : _props$src,
      srcset = props.srcset,
      playerId = props.playerId,
      _props$rounded = props.rounded,
      rounded = _props$rounded === void 0 ? true : _props$rounded,
      _props$errorImageSrc = props.errorImageSrc,
      errorImageSrc = _props$errorImageSrc === void 0 ? HeadshotFallback : _props$errorImageSrc,
      _props$backgroundColo = props.backgroundColor,
      backgroundColor = _props$backgroundColo === void 0 ? universal_color.mlbGrey1 : _props$backgroundColo,
      isLoading = props.isLoading,
      _props$width = props.width,
      width = _props$width === void 0 ? '60px' : _props$width,
      _props$closeUp = props.closeUp,
      closeUp = _props$closeUp === void 0 ? true : _props$closeUp,
      _props$zoomScale = props.zoomScale,
      zoomScale = _props$zoomScale === void 0 ? 1.3 : _props$zoomScale,
      _props$errorZoomScale = props.errorZoomScale,
      errorZoomScale = _props$errorZoomScale === void 0 ? 1 : _props$errorZoomScale;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var zoomLevel = closeUp ? error ? errorZoomScale : zoomScale : 1;
  var providedSrcset = playerId && React.useMemo(function () {
    return constructHeadshotURLSrcset(playerId, zoomLevel, width);
  }, [playerId, zoomLevel, width]) || srcset;
  var providedSrc = playerId && providedSrcset && providedSrcset['1x'] || src;
  var handlers = {
    onError: function onError() {
      setError(true);
    }
  };
  var HeadshotUI = isLoading ? /*#__PURE__*/React__default.createElement(skeleton, {
    width: width,
    height: width,
    isCircle: rounded
  }) : /*#__PURE__*/React__default.createElement(image, _extends({}, props, {
    key: playerId,
    src: providedSrc,
    srcset: providedSrcset,
    rounded: rounded,
    errorImageSrc: errorImageSrc,
    handlers: handlers,
    backgroundColor: backgroundColor,
    sizes: typeof width === 'number' ? "".concat(width, "px") : width
  }));
  return HeadshotUI;
};

module.exports = Headshot;
